import React, { useReducer, useContext } from "react";
import PropTypes from "prop-types";

export const Context = React.createContext();

const initialState = {
  flow: {},
  translations: {},
  isSubmitted: false,
  isLoading: true,
  isErroneous: false,
  appSettings: {}
};

export const ACTIONS_TYPES = {
  SET_IS_LOADING: "SET_IS_LOADING",
  SET_IS_ERRONEOUS: "SET_IS_ERRONEOUS",
  SET_IS_SUBMITTED: "SET_IS_SUBMITTED",
  SET_FLOW: "SET_FLOW",
  SET_TRANSLATIONS: "SET_TRANSLATIONS",
  SET_APP_SETTINGS: "SET_APP_SETTINGS"
};

function reducer(state, { type, payload }) {
  switch (type) {
    case ACTIONS_TYPES.SET_IS_LOADING:
      return {
        ...state,
        isLoading: payload
      };
    case ACTIONS_TYPES.SET_IS_SUBMITTED:
      return {
        ...state,
        isSubmitted: payload
      };
    case ACTIONS_TYPES.SET_IS_ERRONEOUS:
      return {
        ...state,
        isErroneous: payload
      };
    case ACTIONS_TYPES.SET_FLOW:
      return {
        ...state,
        flow: payload
      };
    case ACTIONS_TYPES.SET_TRANSLATIONS:
      return {
        ...state,
        translations: payload
      };
    case ACTIONS_TYPES.SET_APP_SETTINGS:
      return {
        ...state,
        appSettings: payload
      };
    default:
      throw new Error();
  }
}

const GlobalStateProvider = React.memo(({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <Context.Provider
      value={{
        state,
        dispatch
      }}
    >
      {children}
    </Context.Provider>
  );
});

GlobalStateProvider.propTypes = {
  children: PropTypes.node
};
GlobalStateProvider.displayName = "GlobalStateProvider";
export const useGlobalState = () => {
  const { state, dispatch } = useContext(Context);
  return [state, dispatch];
};

export default GlobalStateProvider;
